import { useStore } from "../../stores/StoreContext";
import { FeatureTilesService } from "../LogicServices/FeatureTiles";

export function useFeatureTilesService(): FeatureTilesService {
  const storeContext = useStore();
  return new FeatureTilesService(storeContext);
}
